import React from "react";

import { TrackShipmentDetails } from "../TrackShipmentDetails";
import { OrderPipelineConfig, UnifiedOrderLookupOrder } from "../types";

export const TrackOrderDetails = (props: {
    order: UnifiedOrderLookupOrder;
    config: OrderPipelineConfig | null;
    war_link: string;
}): React.JSX.Element => {
    return (
        <>
            {props.order.shipments.map((shipment, i) => (
                <TrackShipmentDetails
                    key={i}
                    order={props.order}
                    shipment={shipment}
                    config={props.config}
                    war_link={props.war_link}
                />
            ))}
        </>
    );
};
